// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"213":"871b5987","654":"f98ecef2","787":"11487989","850":"7ebb2599"}[chunkId] + ".css";
};